import { StyleSheet, View } from 'react-native';

import DotsLoader from '@/components/DotsLoader';
import { useScrollListener } from '@/hooks/useScrollListener';
import SeasonMissionsList from '@/components/mission/SeasonMissionsList';
import { useGetSeasonMissions } from '@/api/hooks/seasonMissionHooks';

const Missions = () => {
  const { scrollEnabled, scrollHandler } = useScrollListener();

  const { data: missionsData, isLoading, refetch, isRefetching } = useGetSeasonMissions();

  return (
    <View style={style.container}>
      {isLoading || isRefetching ? (
        <DotsLoader />
      ) : (
        <SeasonMissionsList
          onScroll={scrollHandler}
          scrollEnabled={scrollEnabled}
          missionsData={missionsData}
          refetch={refetch}
          isRefetching={isRefetching}
          onEndReached={() => {}}
          isFetchingNextPage={false}
        />
      )}
    </View>
  );
};

export default Missions;

const style = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 18,
    height: '100%'
  }
});
